import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {BaseComponent} from '../base.component';
import * as SharedModels from '@shared-models/index';
import {Router} from '@angular/router';
import {AppConfigurationService} from '@ui-app/services/app-configuration.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {NavigationItemNames} from '@shared-models/common.enums';
import {MatMenuTrigger} from '@angular/material/menu';
import {CountryEnum} from '@shared-models/common.models';

@Component({
    selector: 'ui-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less']
})
export class HeaderComponent extends BaseComponent implements OnChanges {

    constructor(
        public router: Router,
        private appConfigurationService: AppConfigurationService,
    ) {
        super();
    }

    @ViewChild('menuTrigger', {static: true}) menuTriggerChild: MatMenuTrigger;

    @Input() user: SharedModels.CM.IUserData;
    @Input() userPhotoFile: Blob;
    @Input() shouldShowUserProfile = false;
    @Input() shouldShowHeaderMenu = false;
    @Input() shouldShowHeader = false;
    @Input() navigationItems: SharedModels.CM.NavigationItem[] = [];
    @Input() IsEmployeeSearchAccessible: boolean = false;

    logoNavigateLink: SharedModels.CM.LogoNavigation = null;

    protected readonly window = window;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.user && this.user !== null && this.navigationItems != null) {
            this.logoNavigateLink = this.setLogoRedirection(this.user.userRoleId);
        }
    }

    setLogoRedirection(userRoleId: number): SharedModels.CM.LogoNavigation {
        switch (userRoleId) {
            case SharedModels.CE.UserRoleEnum.EmployeeUSI:
            case SharedModels.CE.UserRoleEnum.Employee:
            // FullTimeEmployee && ContractorsOrInterns roles match Employee
            case SharedModels.CE.UserRoleEnum.FTE:
            case SharedModels.CE.UserRoleEnum.CLE:
            case SharedModels.CE.UserRoleEnum.EchoPartner:
            case SharedModels.CE.UserRoleEnum.CTH: {
                return {
                    url: `/profile/${this.user.userId}`,
                    queryParams: {}
                };
            }
            case SharedModels.CE.UserRoleEnum.PreHire: {
                return null;
            }
            default: {
                return {
                    url: this.navigationItems.find(item => item.itemName === NavigationItemNames.BadgeRequests).routerLink,
                    queryParams: {
                        categoryId: SharedModels.CE.BadgeRequestsCategoryId.All
                    }
                };
            }
        }
    }

    isAvailableForCurrentUserRole(navigationItem: SharedModels.CM.NavigationItem): boolean {
        const availableForRoles = navigationItem.availableForRoles;
        if (!this.user) {
            return false;
        }
        return !!availableForRoles?.find(roleId => this.user.userRoleId === roleId);
    }

    closeNavigationItem(navigationItem: SharedModels.CM.NavigationItem): void {
        navigationItem.isOpened = false;
        this.menuTriggerChild.closeMenu();
    }

    isAvailableForCurrentConfiguration$(itemName: SharedModels.CM.NavigationItem['itemName']): Observable<boolean> {
        return this.appConfigurationService.isSettingEnabled$(SharedModels.CE.AppConfigurationSettings.IsIndividualMobileBadgeEnabled)
            .pipe(
                map((isIndividualMobileBadgeEnabled) => {
                    return itemName === SharedModels.CE.NavigationItemNames.IndividualRequests ?
                        isIndividualMobileBadgeEnabled :
                        true;
                })
            );
    }

    isEmployeeSearchAvailableForCurrentUser() { //As access is restricted to only one user, this method is hardcoded to return true for that user
        if (this.IsEmployeeSearchAccessible) {
            return true;
        } else return false;
    }
}
